import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";

// IMPORTANTE: Obtén esta configuración de Firebase Console
// Ve a: Configuración del proyecto > Tus apps > Web
const firebaseConfig = {
    apiKey: "AIzaSyAkJXhO0Q8DAqUNqqUSlhX6XuLyHH5cDL8",
    authDomain: "profase-7f42e.firebaseapp.com",
    projectId: "profase-7f42e",
    storageBucket: "profase-7f42e.firebasestorage.app",
    messagingSenderId: "194121806359",
    appId: "1:194121806359:web:2d952e39ae7759e4bc2252"
};

// IMPORTANTE: Obtén esta key de Firebase Console
// Ve a: Cloud Messaging > Web Push certificates > Generar par de claves
const VAPID_KEY = "BPAsVr9IsqjD2JS-zuIxHL9Ufw7R3HCswkks0GAV-Mki6rpn2IXUyJ6pU-8JB6HiM-7Qdxcx4M1EvPYrSzjcKb4"; // Tu clave pública completa

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Messaging (solo en navegador)
let messaging: Messaging | null = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
}

// ============================================
// Función para registrar el Service Worker
// ============================================
export const registerServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
    if (!('serviceWorker' in navigator)) {
        console.error('Service Workers no soportados en este navegador');
        return null;
    }

    try {
        // Desregistrar SWs anteriores (solo para desarrollo)
        const existingRegistrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of existingRegistrations) {
            // await registration.unregister();
        }

        console.log('📝 Registrando Service Worker...');

        const registration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js',
            {
                scope: '/',
                updateViaCache: 'none'
            }
        );

        console.log('✅ Service Worker registrado');

        // Esperar a que esté activo
        await navigator.serviceWorker.ready;
        console.log('✅ Service Worker activo');

        return registration;
    } catch (error) {
        console.error('❌ Error registrando Service Worker:', error);
        return null;
    }
};


export const requestNotificationPermission = async (): Promise<{
    success: boolean;
    token?: string;
    error?: string;
    errorType?: 'permission-denied' | 'not-supported' | 'brave-blocked' | 'unknown';
}> => {
    try {
        // Verificar soporte
        if (!('Notification' in window)) {
            return {
                success: false,
                error: 'Las notificaciones no están soportadas en este navegador',
                errorType: 'not-supported'
            };
        }

        if (!messaging) {
            return {
                success: false,
                error: 'Firebase Messaging no está disponible',
                errorType: 'not-supported'
            };
        }

        // Detectar Brave
        const isBrave = !!(navigator as any).brave;
        if (isBrave) {
            console.warn('⚠️ Brave detectado - puede requerir configuración adicional');
        }

        // Registrar Service Worker
        console.log('📝 Paso 1: Registrando Service Worker...');
        const registration = await registerServiceWorker();

        if (!registration) {
            return {
                success: false,
                error: 'No se pudo registrar el Service Worker',
                errorType: 'unknown'
            };
        }

        // Esperar un momento para que el SW esté completamente listo
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Solicitar permiso
        console.log('📝 Paso 2: Solicitando permiso...');
        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
            console.warn('⚠️ Permiso denegado');
            return {
                success: false,
                error: 'El usuario denegó los permisos de notificación',
                errorType: 'permission-denied'
            };
        }

        console.log('✅ Permiso concedido');

        // Obtener token FCM
        console.log('📝 Paso 3: Obteniendo token FCM...');
        const token = await getToken(messaging, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (!token) {
            return {
                success: false,
                error: 'No se pudo obtener el token FCM',
                errorType: 'unknown'
            };
        }

        console.log('✅ Token FCM obtenido:', token);

        const notiRequest = {
            token
        };

        // POST token to backend so the server can send push notifications to this device
        try {
            console.log('📝 Paso 4: Registrando token en el backend...');
            const response = await fetch('/api/usuario-notificaciones/firebase', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(notiRequest),
            });

            if (!response.ok) {
                console.warn('⚠️ No se pudo registrar el token en el backend:', response.status, response.statusText);
            } else {
                console.log('✅ Token registrado en el backend');
            }
        } catch (backendError) {
            // Non-fatal: the token was still obtained successfully
            console.warn('⚠️ Error al enviar el token al backend:', backendError);
        }

        return {
            success: true,
            token
        };

    } catch (error) {
        console.error('❌ Error:', error);

        // Manejo específico de errores
        if (error instanceof Error) {
            // Error de Brave
            if (error.message.includes('authentication credential') ||
                error.message.includes('push service')) {
                return {
                    success: false,
                    error: 'Brave bloquea las notificaciones de Google. Ve a brave://settings/privacy y activa "Usar servicios de Google para mensajería push"',
                    errorType: 'brave-blocked'
                };
            }
        }

        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
            errorType: 'unknown'
        };
    }
};

// ============================================
// Función para escuchar mensajes en primer plano
// ============================================
export const onMessageListener = (callback: (payload: any) => void) => {
    if (!messaging) {
        console.error('Messaging no disponible');
        return () => { };
    }

    return onMessage(messaging, async (payload) => {
        console.log('📨 Mensaje recibido en primer plano:', payload);

        // Notify inbox (and any other listener) that new mail has arrived
        window.dispatchEvent(new CustomEvent('profase:inbox:refresh', { detail: payload }));

        try {
            console.log('new message arrived!', payload);
            const response = await fetch('http://localhost:29876/api/sync', {
                method: 'GET', // o POST si tu API lo requiere
            });
        } catch (error) {
            const audio = new Audio('/assets/audio/alert.mp3');
            audio.play()
                .then(() => {
                    console.log('🔔 Sonido habilitado');
                })
                .catch(err => console.warn('No se pudo reproducir:', err));

            const notification = new Notification(payload?.data?.title + '', {
                body: payload?.data?.body,
                icon: "/logo.png", // opcional
            });
        }
    });
    // callback(payload);

};

export { messaging };